export const translations = {
  en: {
    nav: {
      services: "Services",
      commodities: "Commodities",
      portfolio: "Portfolio",
      legality: "Legality",
      blog: "Blog",
      contact: "Contact",
      cta: "Free Consultation",
    },
    hero: {
      badge: "NIB 2103230032415 · Operating Since 2023",
      title_1: "Your Business Bridge",
      title_2: "to the",
      title_em: "Global Market",
      subtitle:
        "PT. Dira Baraka Mulia is a Medan-based trading company supporting export, import, commodities, and licensed-partner coordination based on each transaction's requirements.",
      cta_primary: "Free Consultation",
      cta_secondary: "View Our Services",
      scroll: "Scroll",
    },
    stats: {
      transactions: "Export & Import Transactions",
      partners: "Active Business Partners",
      countries: "Export Destination Countries",
      commodities: "Commodities Traded",
    },
    reach: {
      tag: "National Reach",
      title_1: "From",
      title_em: "Sabang to Merauke",
      title_2: "— We're Here for Your Business",
      lead: "Headquartered in the heart of North Sumatra, PT. Dira Baraka Mulia serves clients across all of Indonesia. Wherever your business is, we're ready to be your trade gateway to national and global markets.",
      mapTitle: "Service Coverage Map",
      points: [
        { icon: "Building2", title: "HQ: Medan, North Sumatra", desc: "Strategically located at Grand Jati Junction Mall, near Belawan Port — one of the largest export-import ports in western Indonesia." },
        { icon: "Globe2", title: "Serving All of Indonesia", desc: "Our clients are spread from Aceh to Papua. With digital communication and a national logistics network, distance is never a barrier." },
        { icon: "Anchor", title: "Access to Major Ports", desc: "Connected to Belawan (Medan), Tanjung Priok (Jakarta), Tanjung Perak (Surabaya), and Makassar — Indonesia's most critical export-import routes." },
        { icon: "Wifi", title: "Remote Coordination", desc: "Consultations, document review, and shipment updates can be coordinated online, subject to the transaction scope and responsible parties." },
      ],
      ctaLabel: "Reach Out Today",
      provinces: "Provinces Covered",
      partnerCities: "Key Partner Cities",
      hq: "HQ Office in Medan",
      legend: { hq: "Head Office", city: "Partner City" },
    },
    services: {
      tag: "Our Services",
      title_1: "Structured",
      title_em: "Trading Solutions",
      lead: "We define the commercial scope, document requirements, responsible parties, and licensed partners before execution.",
      items: [
        { icon: "Ship", title: "Export Services", desc: "Commercial document preparation and shipping coordination are scoped after checking the goods, destination, and applicable requirements.", tag: "Export" },
        { icon: "Plane", title: "Import Services", desc: "Import coordination is assessed per product, importer eligibility, permits, and customs requirements before an engagement is accepted.", tag: "Import" },
        { icon: "Tag", title: "Undername Assessment", desc: "Available only after due diligence, product-permit verification, and a written allocation of responsibilities; it is not a way to bypass licensing rules.", tag: "Undername" },
        { icon: "Handshake", title: "General Trading", desc: "We handle wholesale trading of various commodities — agricultural products, food ingredients, household appliances, and spare parts.", tag: "Trading" },
        { icon: "FileCheck2", title: "Document Coordination", desc: "We help prepare commercial documents and coordinate authorized customs brokers, surveyors, or issuing authorities where required.", tag: "Documents" },
        { icon: "Globe", title: "Trade Consulting", desc: "Want to enter the export market but unsure where to start? Get in-depth consulting on international trade strategy, regulations, and feasibility.", tag: "Consulting" },
      ],
    },
    advantages: {
      tag: "Why Choose Us",
      title_1: "Company Information",
      title_em: "You Can Verify",
      lead: "Company records and transaction scope should be checked before engagement. We state responsibilities and external licensed parties in writing.",
      experience: "3+ Years",
      experienceLabel: "Of International Trading Expertise",
      points: [
        { icon: "ShieldCheck", title: "Verifiable Company Records", desc: "Registered under NIB No. 2103230032415 and an active company NPWP; transaction-specific requirements remain subject to verification." },
        { icon: "Zap", title: "Defined Process", desc: "Scope, documents, estimated milestones, exclusions, and responsibilities are recorded for each accepted engagement." },
        { icon: "Target", title: "Field Documentation", desc: "Activity documentation is shown separately from regulatory guidance so readers can distinguish experience from general information." },
        { icon: "Network", title: "Licensed-Partner Coordination", desc: "Customs, certification, survey, and logistics work is coordinated with the authorized party required for the transaction." },
      ],
    },
    commodities: {
      tag: "Featured Commodities",
      title_1: "We Trade",
      title_em: "Diverse Commodities",
      lead: "Based on our registered KBLI codes, PT. Dira Baraka Mulia is active in wholesale trading of various strategic commodity sectors.",
      items: [
        "Fertilizers & Agrochemical Products",
        "Food & Beverage Ingredients",
        "Coffee, Tea & Cocoa",
        "Oil-bearing Fruits",
        "Fresh Vegetables",
        "Flowers & Ornamental Plants",
        "Household Appliances",
        "Motorcycle Spare Parts",
        "General Merchandise",
        "Fee/Contract-based Trading",
      ],
    },
    portfolio: {
      tag: "Activity Gallery",
      title_1: "Real Proof of",
      title_em: "Our Work",
      lead: "From customs inspections, container loading, industry visits, to partnership meetings — here's documentation of PT. Dira Baraka Mulia's real activities in the field.",
      captions: [
        "Business Partnership Meeting",
        "Palm Oil Mill Partner Visit",
        "Pre-Export Preparation",
        "Partnership Discussion",
        "Physical Goods Inspection",
        "Port Field Visit",
        "Customs Container Inspection",
        "Bulk Carrier Loading",
        "Field Team at Industrial Site",
      ],
    },
    process: {
      tag: "Workflow",
      title_1: "Easy &",
      title_em: "Structured Process",
      lead: "We simplify complex processes into clear, measurable steps.",
      steps: [
        { title: "Initial Consultation", desc: "Discuss your business needs — commodity, destination, and budget." },
        { title: "Analysis & Quote", desc: "We research regulations, the best routes, and provide a transparent offer." },
        { title: "Document Preparation", desc: "We prepare commercial documents and identify documents that must be issued or filed by an authorized party." },
        { title: "Execution & Shipping", desc: "Coordinating shipping, customs inspection, until goods arrive." },
        { title: "Report & Evaluation", desc: "Complete report and evaluation to ensure your satisfaction." },
      ],
    },
    legality: {
      tag: "Company Legality",
      title_1: "Operating",
      title_em: "With Verifiable Records",
      lead: "The records below identify the company. Product, customs, and transaction-specific permits are verified separately before execution.",
      cards: [
        { icon: "Landmark", title: "Official NIB", main: "Business Registration No.", code: "2103230032415", note: "Valid as API-U across Indonesia" },
        { icon: "FileText", title: "Company NPWP", main: "Registered at KPP Pratama Medan Timur", code: "40.280.287.0-113.000", note: "" },
        { icon: "Flag", title: "PMDN Status", main: "Domestic Investment Registration", code: "Officially Listed at BKPM", note: "" },
        { icon: "Scale", title: "10 Active KBLI Codes", main: "Covering wholesale trading across sectors", code: "Active Since 2023", note: "" },
      ],
    },
    cta: {
      title_1: "Ready to Start Your",
      title_2: "Export & Import Business?",
      desc: "Consult your needs now. Free, no commitment.",
      wa: "Chat WhatsApp Now",
      send: "Send Inquiry",
    },
    contact: {
      tag: "Contact Us",
      title: "We're Ready to Serve Your Business Needs",
      lead: "Our team is ready to respond to your inquiry quickly. Reach us through any of our communication channels.",
      address: "Office Address",
      addressLine: "Grand Jati Junction Mall, Level P1 No. 3A,\nJl. Perintis Kemerdekaan, Kel. Perintis,\nKec. Medan Timur, Kota Medan — North Sumatra 20231",
      phone: "Phone / WhatsApp",
      email: "Email",
      director: "Director",
      hours: "Business Hours",
      hoursLine: "Mon – Fri: 08:00 – 17:00 WIB\nSat: 09:00 – 13:00 WIB",
      formTitle: "Send Inquiry",
      f_name: "Full Name",
      f_company: "Company Name",
      f_phone: "WhatsApp Number",
      f_email: "Email",
      f_service: "Service Needed",
      f_servicePlaceholder: "-- Select Service --",
      f_message: "Message / Details",
      f_msgPlaceholder: "Tell us briefly about your business needs...",
      submit: "Send Message via WhatsApp",
      mapTitle: "Visit Our Office",
    },
    blog: {
      tag: "Insight & News",
      title_1: "Trade",
      title_em: "Insights",
      lead: "Articles, guides, and the latest updates around export-import, customs, and Indonesian commerce.",
      readMore: "Read More",
      backToBlog: "Back to All Articles",
      readingTime: "min read",
      relatedTitle: "More Articles",
      shareOnWa: "Share via WhatsApp",
      searchPlaceholder: "Search articles...",
      categories: "Categories",
      tags: "Tags",
      archive: "Archive",
      popular: "Trending Now",
      allPosts: "All Articles",
      noResults: "No articles match your filters.",
      clearAll: "Clear all filters",
      resultsCount: "articles",
      filteringBy: "Filtering by",
      views: "views",
      authorLabel: "Written by",
      talkToEditor: "Ask the Editor",
      tagsOnPost: "Tagged",
      toc: "On this page",
      share: {
        title: "Share",
        whatsapp: "Share on WhatsApp",
        x: "Share on X",
        linkedin: "Share on LinkedIn",
        copy: "Copy link",
        copied: "Copied",
      },
      newsletter: {
        tag: "Newsletter",
        title: "Trade Insights, Monthly",
        desc: "Field-tested briefings on customs, commodities, and markets — straight to your inbox.",
        placeholder: "your@email.com",
        submit: "Subscribe",
      },
    },
    footer: {
      tagline: "Building bridges between Indonesian businesses and the global market — with trust, speed, and integrity.",
      quickLinks: "Quick Links",
      services: "Services",
      followUs: "Follow Us",
      rights: "All rights reserved.",
      builtWith: "Built with care in Medan.",
    },
  },
  id: {
    nav: {
      services: "Layanan",
      commodities: "Komoditas",
      portfolio: "Portofolio",
      legality: "Legalitas",
      blog: "Blog",
      contact: "Hubungi Kami",
      cta: "Konsultasi Gratis",
    },
    hero: {
      badge: "NIB 2103230032415 · Beroperasi Sejak 2023",
      title_1: "Jembatan Bisnis Anda",
      title_2: "ke",
      title_em: "Pasar Global",
      subtitle:
        "PT. Dira Baraka Mulia adalah perusahaan perdagangan berbasis di Medan yang mendukung ekspor, impor, komoditas, dan koordinasi mitra berizin sesuai kebutuhan setiap transaksi.",
      cta_primary: "Konsultasi Gratis",
      cta_secondary: "Lihat Layanan Kami",
      scroll: "Gulir",
    },
    stats: {
      transactions: "Transaksi Ekspor & Impor",
      partners: "Mitra Bisnis Aktif",
      countries: "Negara Tujuan Ekspor",
      commodities: "Komoditas Diperdagangkan",
    },
    reach: {
      tag: "Jangkauan Nasional",
      title_1: "Dari",
      title_em: "Sabang sampai Merauke",
      title_2: "— Kami Hadir untuk Bisnis Anda",
      lead: "Berkantor di jantung Sumatera Utara, PT. Dira Baraka Mulia melayani klien dari seluruh penjuru Indonesia. Di mana pun bisnis Anda berada, kami siap menjadi jembatan perdagangan ke pasar nasional dan global.",
      mapTitle: "Peta Jangkauan Layanan",
      points: [
        { icon: "Building2", title: "Pusat: Medan, Sumatera Utara", desc: "Berlokasi strategis di Grand Jati Junction Mall, dekat Pelabuhan Belawan — salah satu pelabuhan ekspor-impor terbesar di Indonesia bagian barat." },
        { icon: "Globe2", title: "Melayani Seluruh Indonesia", desc: "Klien kami tersebar dari Aceh hingga Papua. Dengan komunikasi digital dan jaringan logistik nasional, jarak bukan hambatan." },
        { icon: "Anchor", title: "Akses ke Pelabuhan Utama", desc: "Terhubung dengan Belawan (Medan), Tanjung Priok (Jakarta), Tanjung Perak (Surabaya), dan Makassar — jalur ekspor-impor utama Indonesia." },
        { icon: "Wifi", title: "Koordinasi Jarak Jauh", desc: "Konsultasi, pemeriksaan dokumen, dan pembaruan pengiriman dapat dikoordinasikan secara online sesuai ruang lingkup dan penanggung jawab transaksi." },
      ],
      ctaLabel: "Hubungi Kami Sekarang",
      provinces: "Provinsi Terjangkau",
      partnerCities: "Kota Mitra Utama",
      hq: "Kantor Pusat di Medan",
      legend: { hq: "Kantor Pusat", city: "Kota Mitra" },
    },
    services: {
      tag: "Layanan Kami",
      title_1: "Solusi Perdagangan",
      title_em: "Terstruktur",
      lead: "Kami menetapkan ruang lingkup komersial, kebutuhan dokumen, pihak yang bertanggung jawab, dan mitra berizin sebelum pelaksanaan.",
      items: [
        { icon: "Ship", title: "Jasa Ekspor", desc: "Persiapan dokumen komersial dan koordinasi pengiriman ditetapkan setelah pemeriksaan barang, negara tujuan, dan persyaratan yang berlaku.", tag: "Ekspor" },
        { icon: "Plane", title: "Jasa Impor", desc: "Koordinasi impor dinilai per produk, kelayakan importir, perizinan, dan ketentuan kepabeanan sebelum pekerjaan diterima.", tag: "Impor" },
        { icon: "Tag", title: "Penilaian Undername", desc: "Hanya tersedia setelah uji tuntas, verifikasi izin barang, dan pembagian tanggung jawab tertulis; bukan sarana menghindari kewajiban perizinan.", tag: "Undername" },
        { icon: "Handshake", title: "Perdagangan Umum", desc: "Kami melayani perdagangan besar berbagai komoditas — hasil pertanian, bahan makanan, peralatan rumah tangga, hingga suku cadang.", tag: "Trading" },
        { icon: "FileCheck2", title: "Koordinasi Dokumen", desc: "Kami membantu menyiapkan dokumen komersial dan mengoordinasikan PPJK, surveyor, atau instansi penerbit yang berwenang bila dipersyaratkan.", tag: "Dokumen" },
        { icon: "Globe", title: "Konsultasi Perdagangan", desc: "Ingin masuk pasar ekspor tapi bingung mulai dari mana? Kami berikan konsultasi strategi, regulasi, dan studi kelayakan komoditas mendalam.", tag: "Konsultasi" },
      ],
    },
    advantages: {
      tag: "Kenapa Memilih Kami",
      title_1: "Informasi Perusahaan yang",
      title_em: "Dapat Diverifikasi",
      lead: "Legalitas perusahaan dan ruang lingkup transaksi perlu diperiksa sebelum kerja sama. Tanggung jawab serta penggunaan mitra berizin dinyatakan secara tertulis.",
      experience: "3+ Tahun",
      experienceLabel: "Pengalaman di Bidang Perdagangan Internasional",
      points: [
        { icon: "ShieldCheck", title: "Data Perusahaan Terverifikasi", desc: "Terdaftar dengan NIB No. 2103230032415 dan NPWP perusahaan aktif; persyaratan khusus transaksi tetap harus diverifikasi." },
        { icon: "Zap", title: "Proses Terdefinisi", desc: "Ruang lingkup, dokumen, perkiraan tahapan, pengecualian, dan tanggung jawab dicatat untuk setiap pekerjaan yang diterima." },
        { icon: "Target", title: "Dokumentasi Lapangan", desc: "Dokumentasi kegiatan dipisahkan dari panduan regulasi agar pembaca dapat membedakan pengalaman dan informasi umum." },
        { icon: "Network", title: "Koordinasi Mitra Berizin", desc: "Pekerjaan kepabeanan, sertifikasi, survei, dan logistik dikoordinasikan dengan pihak berwenang yang sesuai untuk transaksi." },
      ],
    },
    commodities: {
      tag: "Komoditas Unggulan",
      title_1: "Kami Berdagang",
      title_em: "Beragam Komoditas",
      lead: "Berdasarkan KBLI terdaftar, PT. Dira Baraka Mulia aktif dalam perdagangan besar berbagai jenis komoditas strategis.",
      items: [
        "Pupuk & Produk Agrokimia",
        "Bahan Makanan & Minuman Pertanian",
        "Kopi, Teh & Kakao",
        "Buah Berminyak",
        "Sayuran Segar",
        "Bunga & Tanaman Hias",
        "Peralatan Rumah Tangga",
        "Suku Cadang Sepeda Motor",
        "Berbagai Macam Barang Umum",
        "Perdagangan Berbasis Fee / Kontrak",
      ],
    },
    portfolio: {
      tag: "Galeri Kegiatan",
      title_1: "Bukti Nyata",
      title_em: "Kerja Kami",
      lead: "Dari pemeriksaan bea cukai, loading kontainer, kunjungan industri, hingga rapat kemitraan — dokumentasi aktivitas nyata tim PT. Dira Baraka Mulia di lapangan.",
      captions: [
        "Rapat Kemitraan Bisnis",
        "Kunjungan Mitra Pabrik Kelapa Sawit",
        "Persiapan Sebelum Ekspor",
        "Pertemuan Kemitraan",
        "Pemeriksaan Fisik Barang",
        "Kunjungan Lapangan Pelabuhan",
        "Inspeksi Kontainer Bea Cukai",
        "Bongkar Muat ke Bulk Carrier",
        "Tim Lapangan di Lokasi Industri",
      ],
    },
    process: {
      tag: "Alur Kerja",
      title_1: "Proses",
      title_em: "Mudah & Terstruktur",
      lead: "Kami menyederhanakan proses yang kompleks menjadi langkah-langkah yang jelas dan terukur.",
      steps: [
        { title: "Konsultasi Awal", desc: "Diskusikan kebutuhan bisnis Anda — komoditas, tujuan, dan anggaran." },
        { title: "Analisis & Penawaran", desc: "Kami riset regulasi, jalur terbaik, dan berikan penawaran transparan." },
        { title: "Persiapan Dokumen", desc: "Kami menyiapkan dokumen komersial dan mengidentifikasi dokumen yang wajib diterbitkan atau diajukan pihak berwenang." },
        { title: "Eksekusi & Pengiriman", desc: "Koordinasi pengiriman, pemeriksaan bea cukai, hingga barang sampai tujuan." },
        { title: "Laporan & Evaluasi", desc: "Laporan lengkap dan evaluasi untuk memastikan kepuasan Anda." },
      ],
    },
    legality: {
      tag: "Legalitas Perusahaan",
      title_1: "Beroperasi Secara",
      title_em: "Dengan Data Terverifikasi",
      lead: "Data berikut mengidentifikasi perusahaan. Izin khusus barang, kepabeanan, dan transaksi diverifikasi terpisah sebelum pelaksanaan.",
      cards: [
        { icon: "Landmark", title: "NIB Resmi", main: "Nomor Induk Berusaha", code: "2103230032415", note: "Berlaku sbg API-U di seluruh Indonesia" },
        { icon: "FileText", title: "NPWP Perusahaan", main: "Terdaftar di KPP Pratama Medan Timur", code: "40.280.287.0-113.000", note: "" },
        { icon: "Flag", title: "Status PMDN", main: "Penanaman Modal Dalam Negeri", code: "Terdaftar Resmi BKPM", note: "" },
        { icon: "Scale", title: "10 KBLI Aktif", main: "Mencakup perdagangan besar berbagai sektor", code: "Aktif Sejak 2023", note: "" },
      ],
    },
    cta: {
      title_1: "Siap Memulai Bisnis",
      title_2: "Ekspor & Impor Anda?",
      desc: "Konsultasikan kebutuhan Anda sekarang. Gratis, tanpa komitmen.",
      wa: "Chat WhatsApp Sekarang",
      send: "Kirim Pesan / Inquiry",
    },
    contact: {
      tag: "Kontak Kami",
      title: "Kami Siap Melayani Kebutuhan Bisnis Anda",
      lead: "Tim kami siap merespons inquiry Anda dengan cepat. Hubungi kami melalui berbagai channel komunikasi.",
      address: "Alamat Kantor",
      addressLine: "Grand Jati Junction Mall, Level P1 No. 3A,\nJl. Perintis Kemerdekaan, Kel. Perintis,\nKec. Medan Timur, Kota Medan — SUMUT 20231",
      phone: "Telepon / WhatsApp",
      email: "Email",
      director: "Direktur",
      hours: "Jam Operasional",
      hoursLine: "Senin – Jumat: 08.00 – 17.00 WIB\nSabtu: 09.00 – 13.00 WIB",
      formTitle: "Kirim Pesan / Inquiry",
      f_name: "Nama Lengkap",
      f_company: "Nama Perusahaan",
      f_phone: "No. WhatsApp",
      f_email: "Email",
      f_service: "Layanan yang Dibutuhkan",
      f_servicePlaceholder: "-- Pilih Layanan --",
      f_message: "Pesan / Detail Kebutuhan",
      f_msgPlaceholder: "Ceritakan kebutuhan bisnis Anda secara singkat...",
      submit: "Kirim Pesan via WhatsApp",
      mapTitle: "Kunjungi Kantor Kami",
    },
    blog: {
      tag: "Wawasan & Berita",
      title_1: "Wawasan",
      title_em: "Perdagangan",
      lead: "Artikel, panduan, dan update terbaru seputar ekspor-impor, kepabeanan, dan perdagangan Indonesia.",
      readMore: "Baca Selengkapnya",
      backToBlog: "Kembali ke Semua Artikel",
      readingTime: "menit baca",
      relatedTitle: "Artikel Lainnya",
      shareOnWa: "Bagikan via WhatsApp",
      searchPlaceholder: "Cari artikel...",
      categories: "Kategori",
      tags: "Tag",
      archive: "Arsip",
      popular: "Sedang Tren",
      allPosts: "Semua Artikel",
      noResults: "Tidak ada artikel yang cocok dengan filter Anda.",
      clearAll: "Hapus semua filter",
      resultsCount: "artikel",
      filteringBy: "Filter aktif",
      views: "dilihat",
      authorLabel: "Ditulis oleh",
      talkToEditor: "Tanya Redaksi",
      tagsOnPost: "Tag",
      toc: "Daftar isi",
      share: {
        title: "Bagikan",
        whatsapp: "Bagikan via WhatsApp",
        x: "Bagikan di X",
        linkedin: "Bagikan di LinkedIn",
        copy: "Salin tautan",
        copied: "Tersalin",
      },
      newsletter: {
        tag: "Newsletter",
        title: "Trade Insights, Bulanan",
        desc: "Briefing dari lapangan tentang kepabeanan, komoditas, dan pasar — langsung ke inbox Anda.",
        placeholder: "email@anda.com",
        submit: "Berlangganan",
      },
    },
    footer: {
      tagline: "Membangun jembatan antara bisnis Indonesia dan pasar global — dengan kepercayaan, kecepatan, dan integritas.",
      quickLinks: "Tautan Cepat",
      services: "Layanan",
      followUs: "Ikuti Kami",
      rights: "Seluruh hak cipta dilindungi.",
      builtWith: "Dibangun dengan hati di Medan.",
    },
  },
};
